import React from 'react';
import { dealValueShow, judgeArr } from '@/shared/functions';
import { fontEndConfig } from '@/shared/utils';
import { Tag } from 'antd';
import styled from 'styled-components';
const Root = styled.div `
  .left {
    .left__sessionName {
      margin-right: 8px;
      .roundName {
        font-size: 16px;
        color: #1a1a1a;
        margin-right: 5px;
        word-break: break-all;
      }
      .tag {
        color: #666;
        height: 18px;
        line-height: 1.3;
        margin-right: 0;
        background-color: #f2f3f5;
        border: solid 1px #eaeaea;
      }
    }
    .left__sessionBasic {
      font-size: 12px;
      color: #999;
      margin-top: 8px;
    }
    .left__sessionTime {
      font-size: 12px;
      color: #999;
    }
  }
  .right {
    flex-shrink: 0;
  }
`;
export default function BasicInfo(props) {
    const { basicInfo, type = 'sceneManage', className, style } = props;
    const { roundName, roundCode, productNumBak, imgUrl = require('@/assets/Common/carDefault@3x.png'), auctionMode, status, preStartDate, startTimeStr, preStartTime, simulcastDateTime, deadlineOfStartBidding, auctionModeName, } = basicInfo;
    // 展示时间部分
    const renderTime = (() => {
        switch (type) {
            case 'sceneManage':
                /**
                   * simulcastDateTime: 现场拍|暗拍|车道拍  开始时间  超级拍现场拍|超级拍车道拍  竞拍开始时间
                   * preStartDate: 超级拍现场拍|超级拍车道拍  投标开始年月日
                   * preStartTime: 超级拍现场拍|超级拍车道拍  投标开始时分秒
                   * deadlineOfStartBidding: 超级拍现场拍  竞拍截止时间
                   */
                const tbkssj = preStartDate || preStartTime ?
                    `${dealValueShow(preStartDate)} ${dealValueShow(preStartTime)}` :
                    fontEndConfig.noValueReplace;
                switch (auctionMode) {
                    case 1011: // 超级拍现场拍
                        switch (status) {
                            case 0: // 待发拍
                            case 1: // 预展中
                            case 5: // 投标中
                            case 4: // 已撤销
                                return [
                                    { label: '投标开始时间', value: tbkssj },
                                    { label: '竞拍有效时间', value: `${simulcastDateTime}～${deadlineOfStartBidding}` },
                                ];
                            case 2: // 竞拍中
                            case 3: // 已结束
                                return [
                                    { label: '投标开始时间', value: tbkssj },
                                    { label: '竞拍开始时间', value: simulcastDateTime },
                                ];
                        }
                        break;
                    case 1021: // 超级拍车道拍
                        return [
                            { label: '投标开始时间', value: tbkssj },
                            { label: '竞拍开始时间', value: simulcastDateTime },
                        ];
                    case 1: // 现场拍
                    case 2: // 暗拍
                    case 1001: // 车道拍
                    default:
                        return [{ label: '联播开始时间', value: simulcastDateTime }];
                }
                break;
            case 'bidManage':
                switch (auctionMode) {
                    case 1011:
                    case 1021:
                        return [{ label: '场次开始时间', value: preStartDate }];
                    default:
                        return [{ label: '场次开始时间', value: startTimeStr }];
                }
        }
        return [];
    })();
    return (<Root className={`flex__row-btS ${className}`} style={style}>
      <div className="left">
        <div className="left__sessionName">
          <span className="roundName">{dealValueShow(roundName)}</span>
          {auctionModeName && <Tag className="tag"> {dealValueShow(auctionModeName)}</Tag>}
        </div>
        <div className="left__sessionBasic">
          编号{dealValueShow(roundCode)}
          &emsp;|&emsp;
          {dealValueShow(productNumBak)}辆车
        </div>
        <div className="left__sessionTime flex__row-startS">
          <div style={{ width: 85 }}>
            {judgeArr(renderTime) && renderTime.map(item => <div key={item.label}>{item.label}：</div>)}
          </div>
          <div style={{ width: 150 }}>
            {judgeArr(renderTime) && renderTime.map(item => <div key={item.label}>{dealValueShow(item.value)}</div>)}
          </div>
        </div>
      </div>
      <img className="right" src={imgUrl} width={81} height={61}/>
    </Root>);
}
